<!-- eslint-disable vue/singleline-html-element-content-newline -->
<!-- 大屏-数据类型选择组件 -->
<template>
  <div class="flex">
    <div style="line-height: 32px; margin-right: 10px">数据类型</div>
    <el-radio-group v-model="val" style="margin-right: 15px" @change="change">
      <el-radio-button label="实际值"> 实际值 </el-radio-button>
      <el-radio-button label="示数值"> 示数值 </el-radio-button>
    </el-radio-group>
  </div>
</template>
<script setup>
import { ref, watch } from 'vue';

// eslint-disable-next-line newline-after-var
const emits = defineEmits(['update:modelValue', 'change']),
  props = defineProps({
    modelValue: {
      type: String,
      default: '实际值'
    }
  });
let val = ref();

// eslint-disable-next-line one-var
const change = () => {
  emits('change');
};

//监听函数
watch(
  () => props.modelValue,
  (newValue) => {
    val.value = newValue;
  },
  {
    immediate: true, //watch会在创建后立即执行一次
    deep: true //监听深度嵌套的对象属性
  }
);

//监听函数
watch(
  () => val.value,
  (newValue) => {
    emits('update:modelValue', newValue);
  },
  {
    immediate: true, //watch会在创建后立即执行一次
    deep: true //监听深度嵌套的对象属性
  }
);
</script>
<style lang="scss" scoped>
.body {
  display: flex;
  align-items: center;
  gap: 5px;
  // padding: 10px 0 10px 15px;
  font-size: 15px;
  font-weight: bold;
  color: #12151a;
}
.icon {
  width: 20px;
  height: 20px;
}
.icon-up {
  width: 13px;
  height: 13px;
}
</style>
